import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { PromoLabel } from '@/components/LabelsSection';
import { checkIsEasterPromoAvailable } from '@/helpers/easter';
import { bonusRestrictedGroups, someGroupMember } from '@/helpers/user';
import { isWheelPromoAvailableDate } from '@/helpers/wheel';
import { useEasterLabel } from '@/modules/easterMissions/hooks/useEasterLabel';
import { checkIsScratchGameAvailable } from '@/modules/scratchGame/helpers';
import { useCommonStore } from '@/store/commonStore';

const scratchGameBg = '/labels/scratch-game-bg.webp';
const scratchGameLabel = '/labels/scratch-game-label.webp';
const wheelBg = '/labels/hallow-bg.webp';
const wheelLabel = '/labels/hallow-label.webp';

export const useLabels = (): PromoLabel[] => {
  const {
    user,
    cmsConfig,
    scratchGameData,
    bonanzaPromoMenuData,
    pendingBonanzaPromoMenuData,
  } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      cmsConfig: state.cmsConfig,
      scratchGameData: state.scratchGameData,
      bonanzaPromoMenuData: state.bonanzaPromoMenuData,
      pendingBonanzaPromoMenuData: state.pendingBonanzaPromoMenuData,
    }))
  );

  const easterLabel = useEasterLabel();

  return useMemo(
    () => [
      {
        character: bonanzaPromoMenuData?.menu.unloggedCharacter.url,
        background: bonanzaPromoMenuData?.menu.bg.url,
        url: '/bonanza',
        available:
          !user &&
          !!bonanzaPromoMenuData &&
          cmsConfig?.bonanzaPromo.availableByDate,
        isLoading: pendingBonanzaPromoMenuData,
      },
      {
        character: wheelLabel,
        background: wheelBg,
        url: '/hallowheel',
        available:
          !someGroupMember(bonusRestrictedGroups)(user) &&
          isWheelPromoAvailableDate,
      },
      {
        character: scratchGameLabel,
        background: scratchGameBg,
        url: '/scratch-card',
        available: checkIsScratchGameAvailable(scratchGameData, user),
      },
      {
        ...easterLabel,
        available: checkIsEasterPromoAvailable(user),
      },
    ],
    [
      user,
      cmsConfig,
      scratchGameData,
      bonanzaPromoMenuData,
      pendingBonanzaPromoMenuData,
      easterLabel,
    ]
  );
};
